import { create } from "zustand";
import { UpdateFormAssignmentQuestionCodesDto } from "@green0meter/api-client";

import { ParentSelection } from "@components/common/Table";

type FormAssignmentStore = {
  selectedSections: ParentSelection[];
  setSelectedSections: (selectedSections: ParentSelection[]) => void;
  selectedQuestionCodes: UpdateFormAssignmentQuestionCodesDto[];
  setSelectedQuestionCodes: (ids: UpdateFormAssignmentQuestionCodesDto[]) => void;
  clearSelection: () => void;
  sidePanelOpen: boolean;
  setSidePanelOpen: (isOpen: boolean) => void;
};

export const useFormAssignmentStore = create<FormAssignmentStore>((set) => ({
  selectedSections: [],
  setSelectedSections: (selectedSections) =>
    set(() => ({
      selectedSections: selectedSections,
    })),
  selectedQuestionCodes: [],
  setSelectedQuestionCodes: (ids) =>
    set(() => ({
      selectedQuestionCodes: ids,
    })),
  clearSelection: () =>
    set(() => ({
      selectedSections: [],
      selectedQuestionCodes: [],
    })),
  sidePanelOpen: false,
  setSidePanelOpen: (isOpen) =>
    set(() => ({
      sidePanelOpen: isOpen,
    })),
}));
